module.exports = __webpack_public_path__ + "img/logo.c1a0e1d2.svg";